import React from 'react'
import { interpolate } from '../utils/proposalVariables'
import { getIntroBodyHtml, interpolateRichHtml } from '../utils/introRichText'

const IntroLetter = ({ data, variables, theme }) => {
  const showGreeting = data?.showGreeting !== false
  const showClosing = data?.showClosing !== false
  const bodyHtml = interpolateRichHtml(getIntroBodyHtml(data), variables)
  const signatureBlockEnabled = !!data?.signatureBlockEnabled
  const signatureLogoEnabled = data?.signatureLogoEnabled !== false
  const signatureLogoUrl = signatureLogoEnabled ? (data?.signatureLogoUrl || theme?.logoUrl || '') : ''
  const signatureName = interpolate(data?.signatureName || '', variables)
  const signatureTitle = interpolate(data?.signatureTitle || '', variables)
  const signaturePhone = interpolate(data?.signaturePhone || '', variables)
  const signatureMobile = interpolate(data?.signatureMobile || '', variables)
  const signatureEmail = interpolate(data?.signatureEmail || '', variables)
  const signatureContactRows = [
    [signaturePhone && `Office ${signaturePhone}`, signatureMobile && `Mobile ${signatureMobile}`].filter(Boolean).join(' · '),
    signatureEmail,
  ].filter(Boolean)
  const hasSignatureDetails = signatureLogoUrl || signatureTitle || signatureContactRows.length > 0

  return (
    <div className="proposal-section">
      {showGreeting && data?.greeting && (
        <div className="proposal-intro__greeting">{data.greeting}</div>
      )}
      {bodyHtml && (
        <div
          className="proposal-section__body proposal-rich-text"
          dangerouslySetInnerHTML={{ __html: bodyHtml }}
        />
      )}
      {showClosing && (
        <div className="proposal-intro__closing">
          {data?.closing && <div>{interpolate(data.closing, variables)}</div>}
          {signatureBlockEnabled ? (
            <>
              {signatureName && (
                <div className="proposal-intro__signature-name proposal-intro__signature-name--signoff">
                  {signatureName}
                </div>
              )}
              {hasSignatureDetails && (
                <div className="proposal-intro__signature-block">
                  {signatureLogoUrl && (
                    <img
                      src={signatureLogoUrl}
                      alt="Company logo"
                      className="proposal-intro__signature-logo"
                    />
                  )}
                  <div className="proposal-intro__signature-copy">
                    {signatureTitle && (
                      <div className="proposal-intro__signature-title">{signatureTitle}</div>
                    )}
                    {signatureContactRows.map((row, idx) => (
                      <div className="proposal-intro__signature-contact" key={idx}>{row}</div>
                    ))}
                  </div>
                </div>
              )}
            </>
          ) : (
            <>
              {data?.signatureName && (
                <div className="proposal-intro__signature-name">{signatureName}</div>
              )}
              {data?.signatureTitle && (
                <div className="proposal-intro__signature-title">{signatureTitle}</div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  )
}

export default IntroLetter
